import React from 'react';

// Shared "eyebrow + serif heading + supporting text" block used to open every
// major homepage/listing section, so headings read as one consistent system
// instead of each section inventing its own heading markup.
const SectionHeading = ({ eyebrow, title, description, align = 'center', level = 'h2', className = '' }) => {
  const Heading = level;
  return (
    <div className={`${align === 'center' ? 'text-center mx-auto' : ''} max-w-2xl mb-10 sm:mb-14 ${className}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.14em] uppercase text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-full px-3.5 py-1.5 mb-4">
          {eyebrow}
        </span>
      )}
      <Heading className="serif text-3xl sm:text-4xl text-emerald-950 mb-3">{title}</Heading>
      {description && <p className="text-ink-secondary text-base leading-relaxed">{description}</p>}
    </div>
  );
};

export default SectionHeading;
